import React from 'react'
function Test() {


    return (
        <article>
            <h2><span>Why you might not need a blog</span></h2>
            <span className="date">June 16th, 2019</span>

            <blockquote>Blogs, blogs, blogs! - Steven Ballmer</blockquote>
            <p>I'm just testing here.  You actually do need a blog.</p>

           

        </article>
    )

}
export default Test